import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { ButtonModule } from '../button';
import { ListModule } from '../list';
@NgModule({
  declarations: [SearchBarComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ListModule
  ],
  exports: [SearchBarComponent]
})
export class SearchBarModule { }
